/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '../components/ThemeContext';

import Analytics from '../components/Template/Analytics';
import Navigation from '../components/Template/Navigation';
import SideBar from '../components/Template/SideBar';
import ScrollToTop from '../components/Template/ScrollToTop';
import ContactIcons from '../components/Contact/ContactIcons';

const Main = ({
  children = null,
  fullPage = false,
  title = null,
  description = "Sara Buczna's personal website.",
}) => (
  <ThemeProvider>
    <HelmetProvider>
      <Analytics />
      <ScrollToTop />
      <Helmet titleTemplate="Sara Buczna / %s" defaultTitle="Sara Buczna" defer={false}>
        {title && <title>{title}</title>}
        <meta name="description" content={description} />
        <meta property="og:title" content={title ? `Sara Buczna / ${title}` : 'Sara Buczna'} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title ? `Sara Buczna / ${title}` : 'Sara Buczna'} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      <div id="wrapper">
        <Navigation />
        <div id="main">
          {children}
        </div>
        {!fullPage && <SideBar />}
        {!fullPage && (
          <div id="footer-mobile">
            <ContactIcons />
            <p className="copyright" suppressHydrationWarning>&copy; {new Date().getFullYear()} Sara Buczna</p>
          </div>
        )}
      </div>
    </HelmetProvider>
  </ThemeProvider>
);

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Main;
